export function projectSavings(
  startBalance: number,
  monthlyContribution: number,
  monthsForward: number,
): number[] {
  const out: number[] = [];
  let balance = startBalance;
  for (let i = 0; i < monthsForward; i++) {
    balance = balance + monthlyContribution;
    out.push(balance);
  }
  return out;
}

export function projectDebt(
  startBalance: number,
  monthlyPayment: number,
  annualRate: number,
  monthsForward: number,
): number[] {
  const out: number[] = [];
  const rate = (annualRate ?? 0) / 12;
  let remaining = startBalance;
  for (let i = 0; i < monthsForward; i++) {
    if (remaining <= 0) {
      out.push(0);
      continue;
    }
    const interest = remaining * rate;
    remaining = Math.max(0, remaining + interest - monthlyPayment);
    out.push(remaining);
  }
  return out;
}
